module.exports = __webpack_public_path__ + "static/media/bkash_logo.8d8febc7.svg";